import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Singleton = function Singleton(Base) {
  var _Class;
  return _Class = function (_Base) {
    function _Class() {
      var _this;
      _classCallCheck(this, _Class);
      if (Base.instance) {
        return _possibleConstructorReturn(_this, Base.instance);
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _Class, [].concat(args));
      Object.assign(Base, {
        instance: _this
      });
      return _this;
    }
    _inherits(_Class, _Base);
    return _createClass(_Class);
  }(Base), _Class.instance = null, _Class;
};
export default Singleton;